import React, { useEffect, useRef, useState } from 'react';

export const POLICY_LABEL = { required: 'Required', allowed: 'Allowed', forbidden: 'Forbidden', none: 'Not in policy' };
const OPTIONS = ['required', 'allowed', 'forbidden', 'none'];

// What a profile says about a program: a link showing the value, which becomes a drop down when it is clicked. Choosing a value (or leaving
// the drop down alone) puts the link back. `onChange(value)` is called with required, allowed, forbidden or none.
export default function PolicyValue({ name, value, disabled, busy, title, onChange }) {
  const [editing, setEditing] = useState(false);
  const shown = value || 'none';
  const selectRef = useRef(null);
  // The click on the link already counts as the click on the drop down: open its list straight away.
  useEffect(() => {
    if (!editing) return;
    try { selectRef.current?.showPicker?.(); } catch (ex) { /* the list opens with the next click instead */ }
  }, [editing]);
  // Whatever it shows, the value takes the same room, so the column does not move when the drop down opens.
  if (busy) return <span className="v2-policy"><span className="v2-spin" role="status" aria-label={`Saving ${name}`} /></span>;
  if (editing && !disabled) {
    return (
      <span className="v2-policy">
        <select
          ref={selectRef} className="v2-select" autoFocus value={shown} aria-label={`Policy for ${name}`}
          onChange={(e) => { setEditing(false); onChange(e.target.value); }} onBlur={() => setEditing(false)}
        >
          {OPTIONS.map((o) => <option key={o} value={o}>{POLICY_LABEL[o]}</option>)}
        </select>
      </span>
    );
  }
  return (
    <span className="v2-policy">
      <button type="button" className={`v2-link ${shown}`} disabled={disabled} title={disabled ? title : 'Click to change'} aria-label={`Policy for ${name}`} onClick={() => setEditing(true)}>
        {POLICY_LABEL[shown]}
      </button>
    </span>
  );
}
